module.exports = __webpack_public_path__ + "assets/images/2_Ile1mHzC.png";


//////////////////
// WEBPACK FOOTER
// ../assets/images/index/05.png
// module id = 2176
// module chunks = 0